import { OrderedMap, OrderedSet } from 'immutable';
import { Observable } from 'rxjs';

import type Organization from 'entities/organization/model';

import Api from '../api';

import Volunteer from './model';
import {
  addMultipleAction,
  setTotalVolunteersAction,
  setDisplayedVolunteerIdsAction,
  updateVolunteerStatusAction,
  addAction,
} from './actions';

export default class VolunteersApi {
  static fetch(organization: Organization, query: Record<string, string> = {}) {
    const queryStr = Object.keys(query)
      .filter((key) => query[key])
      .map((key) => `${key}=${query[key]}`)
      .join('&');
    return Api.get(
      `api/organizations/${organization.id}/${
        organization.isCompany() ? 'employees' : 'volunteers'
      }?${queryStr}`
    ).map((result) =>
      [
        result.volunteers?.length > 0 &&
          addMultipleAction(
            OrderedMap(
              result.volunteers.map((volunteer) => [volunteer.id, new Volunteer(volunteer)])
            )
          ),
        setDisplayedVolunteerIdsAction(
          OrderedSet(result.volunteers.map((volunteer) => volunteer.id))
        ),
        'total' in result && setTotalVolunteersAction(result.total),
      ].filter(Boolean)
    );
  }

  static fetchById(id: string) {
    return Api.get(`api/users/${id}`).map((user) => addAction(new Volunteer(user)));
  }

  static update(id: string, data: Record<string, string>) {
    return Api.patch(`api/users/${id}`, data).map((volunteer) =>
      addAction(new Volunteer(volunteer))
    );
  }

  static create(data: Record<string, string>) {
    return Api.post(`api/users`, data).map((volunteer) => addAction(new Volunteer(volunteer)));
  }

  static verify(organization: Organization, userId: string, state: 'approve' | 'reject') {
    return Api.get(`api/organizations/${organization.id}/verifyEmployee/${state}/${userId}`).map(
      (result) => [updateVolunteerStatusAction(userId, result.status)]
    );
  }

  static sendPACUploadEmailNotification(message: string): Observable<void> {
    return Api.post(`api/mails/notifyAboutPACUpload`, { message });
  }
}
